import PageWrapper from "../../components/PageWrapper";
import Activities from "./Activities";
import CreateAssessment from "./CreateAssessment";
import GuideTool from "./GuideTool";
import { useSupabase } from '../../contexts/SupabaseContext';


const Dashboard = () => {
  // src/pages/Dashboard.tsx



  // const { session } = useSupabase();

  // return (
  //   <div>
  //     <h1>Dashboard</h1>
  //     {session && <p>Welcome, {session.user.email}!</p>}
  //   </div>
  // );

  return (
    <PageWrapper classes="row">
      {/* Guide Tool and Create Assessment in one row */}
      <div className="col-12 sm:col-7 lg:col-8 h-[35%] max-h-56 pr-4 cursor-pointer">
        <GuideTool />
      </div>
      <div className="col-12 sm:col-5 lg:col-4 h-[35%] max-h-56 pl-4 cursor-pointer">
        <CreateAssessment />
      </div>

      {/* Activities component */}
      <div className="col-12  h-[65%] min-h-[calc(100%-14rem)] pt-8">
        <Activities />
      </div>
    </PageWrapper>
  );
};

export default Dashboard;
